export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const RISK_CATEGORIES = {
  CONSERVATIVE: { label: 'Conservative', color: '#22c55e', emoji: '🛡️', description: 'Low risk, stable returns' },
  MODERATE: { label: 'Moderate', color: '#3b82f6', emoji: '⚖️', description: 'Balanced risk-reward' },
  AGGRESSIVE: { label: 'Aggressive', color: '#ef4444', emoji: '🚀', description: 'High risk, high returns' },
};

export const INVESTMENT_GOALS = [
  { value: 'WEALTH_CREATION', label: 'Wealth Creation' },
  { value: 'RETIREMENT', label: 'Retirement Planning' },
  { value: 'TAX_SAVING', label: 'Tax Saving' },
  { value: 'EMERGENCY_FUND', label: 'Emergency Fund' },
  { value: 'EDUCATION', label: 'Education Fund' },
];

export const INVESTMENT_HORIZONS = [
  { value: 'SHORT', label: 'Short Term (< 3 years)' },
  { value: 'MEDIUM', label: 'Medium Term (3-7 years)' },
  { value: 'LONG', label: 'Long Term (> 7 years)' },
];

export const RISK_TOLERANCES = [
  { value: 'LOW', label: 'Low — I prefer safety over returns' },
  { value: 'MEDIUM', label: 'Medium — Some risk is okay' },
  { value: 'HIGH', label: 'High — I can handle big swings' },
];

export const LOSS_REACTIONS = [
  { value: 'SELL_ALL', label: 'Sell everything immediately' },
  { value: 'SELL_SOME', label: 'Sell some, keep some' },
  { value: 'HOLD', label: 'Hold and wait' },
  { value: 'BUY_MORE', label: 'Buy more at lower prices' },
];

export const EXISTING_INVESTMENTS = [
  { value: 'NONE', label: 'No investments' },
  { value: 'FD_ONLY', label: 'Fixed Deposits only' },
  { value: 'MUTUAL_FUNDS', label: 'Mutual Funds' },
  { value: 'STOCKS', label: 'Direct Stocks' },
  { value: 'DIVERSIFIED', label: 'Diversified portfolio' },
];

export const PIE_COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'];

export const formatCurrency = (amount) => {
  if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(2)} Cr`;
  if (amount >= 100000) return `₹${(amount / 100000).toFixed(2)} L`;
  return `₹${amount.toLocaleString('en-IN')}`;
};
